import { ItemListSharedByVariant } from "@/components/item-list/types";
import { asFirstName } from "@/domains/string/name";
import { observer } from "mobx-react-lite";
import { ACCOUNT_PROFILE_DISPLAY_NAME_FALLBACK } from "@/domains/common/constants";
import styled from "@emotion/styled";
import { ContactObservable } from "@/store/contacts/ContactObservable";
import { MDSRowItemSlotName } from "@/mds";
import { AccountProfileImage } from "@/components/layout/components/account-profile/account-profile-image";
import { MDSPanelWidths } from "@/mds/foundations";

export interface ItemListItemSharedByBoxProps {
  sharedBy?: ContactObservable;
  sharedByVariant?: ItemListSharedByVariant;
  slot?: MDSRowItemSlotName;
}

export const ItemListItemSharedByBox = observer(
  ({
    sharedBy,
    sharedByVariant = ItemListSharedByVariant.SharedBy,
  }: ItemListItemSharedByBoxProps) => {
    const displayName = sharedBy?.profileDisplayName ?? ACCOUNT_PROFILE_DISPLAY_NAME_FALLBACK;

    const sharingFirstNameText =
      sharedByVariant === "SHARED_BY"
        ? `${asFirstName(displayName)} shared`
        : `${asFirstName(displayName)} added`;

    const sharingFullText =
      sharedByVariant === "SHARED_BY" ? `Shared by ${displayName}` : `Added by ${displayName}`;

    if (!sharedBy) {
      return null;
    }

    return (
      <Wrapper>
        <Container title={sharingFullText}>
          <AccountProfileImage
            size={16}
            photoUrl={sharedBy.profilePhotoUrl}
            displayName={sharedBy.profileDisplayName}
          />
          <Text>{sharingFirstNameText}</Text>
        </Container>
      </Wrapper>
    );
  }
);

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-shrink: 1;
  overflow: hidden;
`;

const Container = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #696e7d;
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 4px;
  gap: 8px;
`;

const Text = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @container mds-row-item (max-width: ${MDSPanelWidths.headerBreakpoint}px) {
    display: none;
    width: 0;
  }
`;
